import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { EmailForm } from 'page/UserDataBanner/EmailForm'
import { PhoneForm } from 'page/UserDataBanner/PhoneForm'
import { store } from 'store/store'

export const UserDataBanner = observer(() => {
  const { open, done } = store.banner
  const { type, title, thanks } = store.options?.email ?? {}
  const phone = type === 'phone'
  const label = title ? title : phone ? i18n('PhoneLabel') : i18n('EmailLabel')

  const onCancel = useLatestCallback(() => {
    store.banner.close()
  })

  if (!open) return null

  return <Banner title={label} onCancel={onCancel}>
    <Vertical gap={12}>
      {!done && !phone && <EmailForm />}
      {!done && phone && <PhoneForm />}
      {done && <Vertical gap={12}>
        <Typo size={16}>{thanks || i18n('SendDataThanks')}</Typo>
        <Button large action={onCancel}>
          {i18n('Close')}
        </Button>
      </Vertical>}
    </Vertical>
  </Banner>
})
